import resume from '../assets/pdf/resume.pdf'
import profile_pic from '../assets/png/profile_pic.png'

export const headerData = {
    name: 'Elsa Heitz',
    title: "",
    desciption: "I am finishing my Master's thesis at École Polytechnique Fédérale de Lausanne (EPFL) " +
        "in Robotics with a minor in Data Sciences, and will be graduating in early 2026. " +
        "I am actively looking for full-time opportunities starting October 2026.",
    image: profile_pic,
    resumePdf: resume
}
